module.exports = __webpack_public_path__ + "img/arrow_down_icon.81556e29.svg";